module.exports = __webpack_public_path__ + "static/media/logo158.4e61f222.png";